import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import cls from '../styles.module.scss'

export const TextLandEn = () => {
    return (
        <HighlightedText
            text="325% Bonus + 400 FREESPINS"
            highlights={[{ word: '325%' }, { word: '400' }]}
            breakBeforeWords={['FREESPINS']}
            breakAfterWords={['Bonus']}
            className={cls.text}
        />
    )
}
